import type Api from "../../../../services/api";
import type { ICredentialsWithServer } from "../../../../utils/credentialsStore";
import { replaceNativeSession } from "../helpers/replaceNativeSession";

/**
 * Signs the driver in again with their new password, because changing it ends all of their sessions.
 * Takes the session from before the change, since a call failing in between clears the current one.
 * Only callers that pass shouldReplaceNativeSession hand the new session to the native app.
 */
export async function signInWithNewPassword(api: Api, session: ICredentialsWithServer, password: string, shouldReplaceNativeSession = false): Promise<void> {
    const auth = await api.callPromise("Authenticate", {
        database: session.credentials.database,
        userName: session.credentials.userName,
        password
    }, true) as { credentials: ICredentials };

    api.setUser(auth.credentials, session.server, session.iamSettings);
    if (shouldReplaceNativeSession) {
        replaceNativeSession(auth.credentials, session.server);
    }
}
